import React, { useState } from 'react'
import { X } from 'lucide-react'
import clsx from 'clsx'

interface PhotoItem {
  id: string
  url: string
  caption?: string
}

interface PhotoGridProps {
  photos: PhotoItem[]
  maxDisplay?: number
  onPhotoClick?: (photo: PhotoItem) => void
}

export default function PhotoGrid({ photos, maxDisplay = 10, onPhotoClick }: PhotoGridProps) {
  const [lightbox, setLightbox] = useState<PhotoItem | null>(null)
  const const_display = photos.slice(0, maxDisplay)
  const remaining = photos.length - maxDisplay

  const openLightbox = (photo: PhotoItem) => {
    if (onPhotoClick) {
      onPhotoClick(photo)
    } else {
      setLightbox(photo)
    }
  }

  if (photos.length === 0) {
    return (
      <div className="text-center py-8 text-text-secondary text-sm">
        Belum ada foto.
      </div>
    )
  }

  return (
    <>
      <div className="grid grid-cols-3 gap-1.5">
        {const_display.map((photo, i) => (
          <div
            key={photo.id}
            className={clsx(
              'relative aspect-square rounded-lg overflow-hidden cursor-pointer group',
              i === 0 && 'col-span-2 row-span-2'
            )}
            onClick={() => openLightbox(photo)}
          >
            <img
              src={photo.url}
              alt={photo.caption || `Photo ${i + 1}`}
              className="w-full h-full object-cover transition-transform duration-200 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-200" />
          </div>
        ))}

        {remaining > 0 && (
          <div className="relative aspect-square rounded-lg overflow-hidden cursor-pointer bg-gray-200 flex items-center justify-center">
            <span className="text-white font-bold text-lg drop-shadow">+{remaining}</span>
            <div className="absolute inset-0 bg-black/30" />
          </div>
        )}
      </div>

      {lightbox && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-4 right-4 text-white p-2 hover:bg-white/10 rounded-full transition-colors"
            onClick={() => setLightbox(null)}
          >
            <X className="w-6 h-6" />
          </button>
          <img
            src={lightbox.url}
            alt={lightbox.caption || ''}
            className="max-w-full max-h-full object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
          {lightbox.caption && (
            <div className="absolute bottom-4 left-4 right-4 text-center text-white text-sm">
              {lightbox.caption}
            </div>
          )}
        </div>
      )}
    </>
  )
}
